// extracted by mini-css-extract-plugin
module.exports = {"spacer":"Button_spacer__3zfrv","textTransformNone":"Button_textTransformNone__3Q-1j"};